"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var financial = _interopRequireWildcard(require("@/api/financial"));
var suplierCouponsApi = _interopRequireWildcard(require("@/api/suplierCouponsApi.js"));
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {},
  data: function data() {
    return {
      constants: this.$constants,
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      supplierOption: [],
      TYPE_OPTIONS: [{
        value: 1,
        label: '系统充值'
      }, {
        value: 2,
        label: '系统扣费'
      }, {
        value: 3,
        label: '订单扣费'
      }, {
        value: 4,
        label: '订单退款'
      }, {
        value: 5,
        label: '售后退款'
      }]
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.handlerGetListData(this.listPram);
    this.searchSupplier('');
  },
  methods: {
    throttle: _throttle.default,
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      if (!this.listPram.supplierId) {
        this.searchSupplier('');
      }
      ;
      this.handlerGetListData(this.listPram);
    },
    handlerGetListData: function handlerGetListData() {
      var _this = this;
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.listLoading = true;
      financial.fundRecordList(pram).then(function (data) {
        _this.listData = data;
        _this.listLoading = false;
      }).catch(function (err) {
        _this.listLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    },
    searchSupplier: function searchSupplier() {
      var _this2 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.supplierOption = [];
      suplierCouponsApi.getAllCompany(keyword).then(function (res) {
        _this2.supplierOption = res || [];
      });
    },
    handleSupplierSearch: function handleSupplierSearch(data) {
      var _this3 = this;
      this.throttle(function () {
        _this3.searchSupplier(data);
      }, 300)();
    },
    exportsList: function exportsList() {
      financial.fundRecordExport(this.listPram).then(function (res) {
        window.open(res.fileName);
      });
    }
  }
};